<template>
    <div id="user-logs-detail-table">
        <v-data-table
                :headers="headers"
                :items="logs"
                class="user-detail-table"
                :items-per-page="15"
                :single-expand="true"
                :expanded.sync="expanded"
                item-key="sum.date"
                show-expand
                loading-text="Adatok betöltése..."
                :loading="this.$store.state.monthlyDetail.detailLoading"
        >

            <template v-slot:item.sum.date="{ item }">
                {{ item.sum.date }} ({{ item.sum.dayname }})
            </template>

            <template v-slot:item.sum.work="{ item }">
                {{ item.sum.work }} <v-icon v-if="item.sum.correction.length != 0" color="orange darken-2">edit</v-icon>
            </template>

            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" style="border: 2px solid #333; border-top: none;">

                   <v-container fluid>
                       <v-row>
                           <v-col>
                               <UserDetailDailyLog :logs="item.logs" />
                               <p v-if="item.sum.message" class="mt-5">
                                   <strong><v-icon>message</v-icon> Napi üzenet:</strong> {{ item.sum.message }}
                               </p>
                           </v-col>
                           <v-col>
                               <UserDetailCorrection :sum="item.sum"/>
                           </v-col>
                       </v-row>
                   </v-container>
                </td>
            </template>

        </v-data-table>
    </div>
</template>

<script>
    import UserDetailCorrection from './UserDetailCorrection'
    import UserDetailDailyLog from "./UserDetailDailyLog";
    export default {
        name: "UserDetailTable",

        data () {
            return {
                expanded: [],
                headers: [
                    {
                        text: 'Dátum',
                        value: 'sum.date',
                        sortable: true,
                    },
                    {
                        text: 'Munkaidő',
                        value: 'sum.work',
                        sortable: true,
                    },
                    {
                        text: 'Szünet',
                        value: 'sum.break',
                        sortable: true,
                    },
                    { text: '', value: 'data-table-expand', class: 'teeest' },
                ]
            }
        },

        components: {
            UserDetailCorrection,
            UserDetailDailyLog
        },

        props: {
            logs: {
                required: true,
            }
        },
    }
</script>

<style lang="scss">

    #user-logs-detail-table {
        #user-detail-expand-table {
            tr {  }
            font-weight: 600;
            .danger { background: #c0392b!important; color: #fff; height: 20px!important; }
            .success { background: #27ae60; color: #fff; }
        }
    }


    .v-data-table tbody tr.v-data-table__expanded__content {
        box-shadow: none;
    }


    tr.v-data-table__expanded.v-data-table__expanded__row td {
        border-top: 2px solid #333;
    }

    tr.v-data-table__expanded.v-data-table__expanded__row td:first-child {
        border-left: 2px solid #333;
    }

    tr.v-data-table__expanded.v-data-table__expanded__row td:last-child {
        border-right: 2px solid #333;
    }

    @media only screen and (max-width: 599px) {
        #user-logs-detail-table {
            table tbody tr td.v-data-table__mobile-row:last-child {
                display: none;
            }

            table tbody tr {
                border-bottom: 1px solid #efefef;
            }
        }
    }
</style>
